// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="form-column">

    <form-section form-title="'Personal data'">
      <form-section-field field-title="'Title'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'title')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'title')"
                ng-model="\$ctrl.profile.individualData.titleId"
                ng-disabled="!\$ctrl.editMode"
                id="cpr_title"
                ng-options="title.id as title.description for title in \$ctrl.dict.CUSTOMER_TITLE">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'First name'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'first_name')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'first_name')"
               ng-model="\$ctrl.profile.individualData.firstName"
               ng-change="\$ctrl.nameChanged()"
               ng-disabled="!\$ctrl.editMode"
               capitalize-input
               type="text"
               id="cpr_first_name"
               maxlength="64"
               placeholder="First name"
               data-toggle="tooltip"
               title="The customer's first name.">
      </form-section-field>
      <form-section-field field-title="'Middle name'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'middle_name')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'middle_name')"
               ng-model="\$ctrl.profile.individualData.middleName"
               ng-change="\$ctrl.nameChanged()"
               ng-disabled="!\$ctrl.editMode"
               capitalize-input
               type="text"
               id="cpr_middle_name"
               maxlength="64"
               placeholder="Middle name"
               data-toggle="tooltip"
               title="The customer's middle name.">
      </form-section-field>
      <form-section-field field-title="'Last name'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'last_name')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'last_name')"
               ng-model="\$ctrl.profile.individualData.lastName"
               ng-change="\$ctrl.nameChanged()"
               ng-disabled="!\$ctrl.editMode"
               capitalize-input
               type="text"
               id="cpr_last_name"
               maxlength="64"
               placeholder="Last name"
               data-toggle="tooltip"
               title="The customer's last name.">
      </form-section-field>

      <button ng-if="\$ctrl.shouldDisplayRiskProfiling"
              class="btn btn-primary pull-right watchlist-button"
              ng-disabled="!\$ctrl.profile.individualData.firstName || !\$ctrl.profile.individualData.lastName || \$ctrl.verifyDone || !\$ctrl.editMode"
              ng-click="\$ctrl.watchlistVerify(\$event)">
        Watchlist verify
      </button>

      <form-section-field field-title="'Extension'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'extension')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'extension')"
               ng-model="\$ctrl.profile.individualData.extensionId"
               ng-disabled="!\$ctrl.editMode"
               id="cpr_extension"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.CUSTOMER_NAME_EXTENSION">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Nickname'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'nickname')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'nickname')"
               ng-model="\$ctrl.profile.individualData.nickname"
               ng-disabled="!\$ctrl.editMode"
               capitalize-input
               type="text"
               id="cpr_nickname"
               maxlength="64"
               placeholder="Nickname"
               data-toggle="tooltip"
               title="The customer's nickname.">
      </form-section-field>
      <form-section-field field-title="'Previous Last Name'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'previous_last_name')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'previous_last_name')"
               ng-model="\$ctrl.profile.individualData.previousLastName"
               ng-disabled="!\$ctrl.editMode"
               capitalize-input
               type="text"
               id="cpr_previous_last_name"
               maxlength="64"
               placeholder="Previous Last name"
               data-toggle="tooltip"
               title="The customer's previous last name if any.">
      </form-section-field>
    </form-section>

    <form-section form-title="'Demographics'">
      <form-section-field field-title="'Gender'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'gender')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'gender')"
                ng-model="\$ctrl.profile.individualData.genderId"
                ng-disabled="!\$ctrl.editMode"
                id="cpr_gender"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.GENDER">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Height'"
                          ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'height_major')
                                  || \$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'height_minor')">
        <div class="horizontal">
          <glue-container append="'Feet'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'height_major')">
            <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'height_major')"
              type="number"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              ng-model="\$ctrl.profile.individualData.heightMajor"
              ng-disabled="!\$ctrl.editMode"
              min="0" max="8"/>
          </glue-container>
          <glue-container append="'Inch'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'height_minor')">
            <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'height_minor')"
              type="number"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              ng-model="\$ctrl.profile.individualData.heightMinor"
              ng-disabled="!\$ctrl.editMode"
              min="0" max="11"/>
          </glue-container>
        </div>
      </form-section-field>
      <form-section-field field-title="'Weight'"
                          ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'weight_major')
                                  || \$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'weight_minor')">
        <div class="horizontal">
          <glue-container append="'Pound'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'weight_major')">
            <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'weight_major')"
              type="number"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              ng-model="\$ctrl.profile.individualData.weightMajor"
              ng-disabled="!\$ctrl.editMode"
              min="0" max="1000"/>
          </glue-container>
          <glue-container append="'Ounce'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'weight_minor')">
            <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'weight_minor')"
              type="number"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              ng-model="\$ctrl.profile.individualData.weightMinor"
              ng-disabled="!\$ctrl.editMode"
              min="0" max="15"/>
          </glue-container>
        </div>
      </form-section-field>
      <form-section-field field-title="'Civil Status'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'civil_status')">
        <div class="horizontal">
          <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'civil_status')"
                  ng-model="\$ctrl.profile.individualData.civilStatusId"
                  ng-disabled="!\$ctrl.editMode"
                  id="cpr_civilStatus"
                  ng-options="entry.id as entry.description for entry in \$ctrl.dict.CIVIL_STATUS">
            <option></option>
          </select>
          <help ng-if="\$ctrl.isMarried()" title="Please add the customer's spouse in the 'Related People' tab"></help>
        </div>
      </form-section-field>
      <form-section-field field-title="'Birth Date'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'birth_date')">
        <date ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'birth_date')"
              ng-model="\$ctrl.profile.individualData.birthDate"
              init-with-null="true"
              ng-disabled="!\$ctrl.editMode"
              ng-change="\$ctrl.updateAge()"
              min="\$ctrl.minBirthDate"
              max="\$ctrl.maxBirthDate"
              id="cpr_birth_date">
        </date>
      </form-section-field>
      <form-section-field field-title="'Age'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'age')">
        <input ng-model="\$ctrl.profile.individualData.age"
               ng-disabled="true"
               type="number"
               id="cpr_age"
               disabled>
      </form-section-field>
      <form-section-field field-title="'Birth place'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'birth_place')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'birth_place')"
               ng-model="\$ctrl.profile.individualData.birthPlace"
               ng-disabled="!\$ctrl.editMode"
               type="text"
               id="cpr_birth_place"
               placeholder="Birth place"
               maxlength="64">
      </form-section-field>
      <form-section-field field-title="'Birth country'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'birth_country')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'birth_country')"
                ng-model="\$ctrl.profile.individualData.birthCountryId"
                ng-disabled="!\$ctrl.editMode"
                id="cpr_birth_country"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.COUNTRY">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Citizenship'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'citizenship')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'citizenship')"
                ng-model="\$ctrl.profile.individualData.citizenshipId"
                ng-disabled="!\$ctrl.editMode"
                id="cpr_citizenship"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.COUNTRY">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Residence'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'demographics', 'residence')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'demographics', 'residence')"
                ng-model="\$ctrl.profile.individualData.residenceId"
                ng-disabled="!\$ctrl.editMode"
                id="cpr_residence"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.COUNTRY">
          <option></option>
        </select>
      </form-section-field>
    </form-section>

    <form-section form-title="'Related people'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'related_people', 'mothers_first_name') || \$ctrl.cfg.visible(\$ctrl.module, 'related_people', 'mothers_middle_name') || \$ctrl.cfg.visible(\$ctrl.module, 'related_people', 'mothers_last_name')">
      <form-section-field field-title="'Mother’s first name'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'related_people', 'mothers_first_name')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'related_people', 'mothers_first_name')"
               ng-model="\$ctrl.profile.individualData.mothersFirstName"
               ng-disabled="!\$ctrl.editMode"
               type="text"
               id="cpr_mothers_first"
               placeholder="First name"
               maxlength="32">
      </form-section-field>
      <form-section-field field-title="'Mother’s middle name'"
                          ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'related_people', 'mothers_middle_name')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'related_people', 'mothers_middle_name')"
               ng-model="\$ctrl.profile.individualData.mothersMiddleName"
               ng-disabled="!\$ctrl.editMode"
               type="text"
               id="cpr_mothers_middle"
               placeholder="Middle name"
               maxlength="32">
      </form-section-field>
      <form-section-field field-title="'Mother’s maiden name'"
                          ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'related_people', 'mothers_last_name')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'related_people', 'mothers_last_name')"
               ng-model="\$ctrl.profile.individualData.mothersLastName"
               ng-disabled="!\$ctrl.editMode"
               type="text"
               id="cpr_mothers_maiden"
               placeholder="Last name"
               maxlength="32">
      </form-section-field>
    </form-section>
  </div>

  <div class="form-column">
    <form-section form-title="'Contact data'">
      <form-section-field field-title="'E-mail address'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'contact_data', 'email')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'contact_data', 'email')"
               ng-model="\$ctrl.profile.individualData.email"
               ng-disabled="!\$ctrl.editMode"
               type="email"
               id="cpr_email"
               placeholder="Email Address"
               maxlength="64">
      </form-section-field>
      <form-section-field field-title="'Landline number'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'contact_data', 'landline_number')">
          <telephone ng-required="\$ctrl.cfg.required(\$ctrl.module, 'address', 'landline_number')"
                     ng-model="\$ctrl.profile.extractedPhones.home.number"
                     ng-disabled="!\$ctrl.editMode"
                     id="cpr_home_phone_number"/>
      </form-section-field>
      <form-section-field field-title="'Mobile number'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'contact_data', 'mobile_number')">
        <telephone ng-model="\$ctrl.profile.extractedPhones.mobile.number"
                   ng-required="\$ctrl.cfg.required(\$ctrl.module, 'contact_data', 'mobile_number')"
                   id="cpr_mobile_phone_number"
                   ng-disabled="!\$ctrl.editMode"
                   ng-change="\$ctrl.mobileNumberChanged()"/>
      </form-section-field>
      <form-section-field field-title="'Type of mobile phone'" ng-if="\$ctrl.module && \$ctrl.cfg.visible(\$ctrl.module, 'contact_data', 'phone_type')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'contact_data', 'phone_type')"
                ng-options="t.type as t.label for t in \$ctrl.phoneTypes"
                ng-model="\$ctrl.profile.mobilePhoneType"
                id="cpr_phone_type"
                ng-disabled="!\$ctrl.editMode">
        </select>
      </form-section-field>
      <form-section-field field-title="'Mobile plan'" ng-if="\$ctrl.profile.extractedPhones.mobile.number && \$ctrl.cfg.visible(\$ctrl.module, 'contact_data', 'mobile_plan')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'contact_data', 'mobile_plan')"
               ng-model="\$ctrl.profile.extractedPhones.mobile.planId"
               ng-disabled="!\$ctrl.editMode"
               id="cpr_mobile_plan"
               ng-options="entry.id as entry.description for entry in \$ctrl.dict.MOBILE_PLAN">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Mobile monthly expense'" ng-if="\$ctrl.profile.extractedPhones.mobile.number &&  \$ctrl.cfg.visible(\$ctrl.module, 'contact_data', 'mobile_monthly_expense')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'contact_data', 'mobile_monthly_expense')"
               ng-model="\$ctrl.profile.extractedPhones.mobile.monthlyExpenseId"
               ng-disabled="!\$ctrl.editMode"
               id="cpr_mobile_montly_expense"
               ng-options="entry.id as entry.description for entry in \$ctrl.dict.MOBILE_MONTHLY_EXPENSE | orderBy:'id'">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Work number'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'contact_data', 'work_number')">
        <telephone ng-required="\$ctrl.cfg.required(\$ctrl.module, 'contact_data', 'work_number')"
                   ng-model="\$ctrl.profile.extractedPhones.work.number"
                   id="cpr_work_phone_number"
                   ng-disabled="!\$ctrl.editMode"/>
      </form-section-field>
    </form-section>

    <form-section ng-if="\$ctrl.module !== 'agent'" form-title="'Compliance'">
      <form-section-field field-title="'Risk level'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'risk_level')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'risk_level')"
                ng-model="\$ctrl.profile.individualData.riskLevelId"
                ng-disabled="!\$ctrl.editMode"
                id="cpr_risk_level"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.CUSTOMER_RISK_LEVEL">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Average monthly deposit amount'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'expected_monthly_transaction')">
        <compliance-non-commensurate-select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'expected_monthly_transaction')"
          ng-model="\$ctrl.profile.individualData.expectedMonthlyTransactionId"
          customer-type="\$ctrl.profile.customerType"
          customer-subtype="\$ctrl.profile.customerSubtype"
          ng-disabled="!\$ctrl.editMode"
          id="cpr_expected_monthly_transaction">
        </compliance-non-commensurate-select>
      </form-section-field>
      <form-section-field field-title="'DOSRI'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'dosri')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'dosri')"
                ng-model="\$ctrl.profile.dosri"
                ng-change="\$ctrl.dosriChanged()"
                ng-disabled="!\$ctrl.editMode"
                boolean-options>
        </select>
      </form-section-field>
      <form-section-field field-title="'DOSRI type'"
                          ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'dosri') && \$ctrl.profile.dosri">
        <select ng-required="true"
                ng-model="\$ctrl.profile.dosriType"
                ng-disabled="!\$ctrl.editMode"
                ng-options="dosriType | prettyEnum for dosriType in \$ctrl.dosriTypes">>
        </select>
      </form-section-field>
      <form-section-field field-title="'Related Party Transaction'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'related_party_transaction')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'related_party_transaction')"
                ng-model="\$ctrl.profile.individualData.relatedPartyTransaction"
                ng-disabled="!\$ctrl.editMode"
                ng-change="\$ctrl.rptChanged()"
                ng-options="entry.value as entry.label | prettyEnum for entry in \$ctrl.relatedPartyTransactions">
          <option value="">Not rpt</option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Related Party Transaction Description'"
                          ng-if="\$ctrl.profile.individualData.relatedPartyTransaction === 'OTHERS'">
        <input ng-required="true"
               ng-model="\$ctrl.profile.individualData.relatedPartyTransactionDescription"
               type="text"
               ng-disabled="!\$ctrl.editMode"
               maxlength="128">
      </form-section-field>
      <form-section-field field-title="'PEP'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'pep')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'pep')"
                ng-model="\$ctrl.profile.individualData.pep"
                ng-disabled="!\$ctrl.editMode"
                boolean-options>
        </select>
      </form-section-field>
      <form-section-field field-title="'Sanctioned entity:'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'sanctioned_entity')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'sanctioned_entity')"
                ng-model="\$ctrl.profile.individualData.sanctionedEntity"
                ng-disabled="!\$ctrl.editMode || !\$ctrl.shouldDisplayRiskProfiling"
                boolean-options>
        </select>
      </form-section-field>
      <form-section-field field-title="'VIP'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'vip')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'vip')"
                ng-model="\$ctrl.profile.individualData.vip"
                ng-disabled="!\$ctrl.editMode"
                boolean-options>
        </select>
      </form-section-field>
      <form-section-field field-title="'Signature upload'"
                          ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'signature_upload')">
        <file-upload ng-model="\$ctrl.profile.individualData.signatureFile"
                     ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'signature_upload')"
                     validate-uploaded
                     max-files="1"
                     name="documentUpload"
                     ng-disabled="!\$ctrl.editMode"
                     show-file-name="false"
                     show-remarks="false"
                     >
        </file-upload>
      </form-section-field>
      <form-section-field field-title="'Picture upload'"
                          ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'compliance', 'picture_upload')">
        <file-upload ng-model="\$ctrl.profile.pictureFile"
                     ng-required="\$ctrl.cfg.required(\$ctrl.module, 'compliance', 'picture_upload')"
                     validate-uploaded
                     max-files="1"
                     max-size="'512KB'"
                     name="documentUpload"
                     ng-disabled="!\$ctrl.editMode"
                     show-file-name="false"
                     show-remarks="false"
                     >
        </file-upload>
      </form-section-field>
    </form-section>

    <form-section ng-if="\$ctrl.module !== 'agent'" form-title="'Other'">
      <span class="alert alert--danger" ng-if="!\$ctrl.isCoMakerMaxTagLimitValid()">
        Max co-maker tag limit should not be less than the total number of the customer's co-made loans
      </span>
      <form-section-field field-title="'Max co-maker limit'">
        <input type="number"
               ng-min="\$ctrl.profile.coMadeLoanIds.length"
               step="1"
               ng-model="\$ctrl.profile.maxComakerTagLimit"
               ng-disabled="!\$ctrl.editMode"/>
      </form-section-field>
      <form-section-field field-title="'Comments'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'other_data', 'comments')">
        <textarea ng-required="\$ctrl.cfg.required(\$ctrl.module, 'other_data', 'comments')"
                ng-model="\$ctrl.profile.comments"
                ng-disabled="!\$ctrl.editMode"
                id="cpr_other_data_comments"
                rows="6"
                maxlength="1024">
        </textarea>
      </form-section-field>
      <form-section-field field-title="'Is PWD?'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'other_data', 'is_pwd')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'other_data', 'is_pwd')"
                ng-model="\$ctrl.profile.isPwd"
                ng-disabled="!\$ctrl.editMode"
                boolean-options>
        </select>
      </form-section-field>
    </form-section>
  </div>

  <div class="form-column">
    <form-section form-title="'Referrals'">
      <form-section-field field-title="'Referred by'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'other_data', 'referred_by')">
      <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'other_data', 'referred_by')"
             ng-model="\$ctrl.profile.referredBy"
             ng-disabled="!\$ctrl.editMode"
             type="text"
             placeholder="Referred by"
             maxlength="255">
      </form-section-field>
    </form-section>
  </div>
  <div class="clearfix"></div>
</ng-form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/individual-data.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;